import { Grid, IconButton, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import {
  customValidation,
  updateMainHeader,
  validations,
} from "../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSSelectField from "../../Components/Select/WSSelect";
import WSButton from "../../Components/Button/WSButton";

export const User: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit } = useForm();
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const id = params?.id;

  const navigate = useNavigate();
  const handleData = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };

  const handleCancelClick = () => {
    navigate("/");
  };

  useEffect(() => {
    updateMainHeader("User");
  });

  breadCrumbsStore.updateBreadCrumbs([
    { "User List": "/user/list" },
    { [!id ? "Add User" : "Update User"]: "/add-user" },
  ]);

  const handleClose = () => {
    navigate("/");
  };
  return (
    <>
      <Grid p={3}>
        <Paper
          elevation={0}
          style={{
            paddingLeft: 20,
            paddingRight: 20,
            marginTop: 0,
            paddingBottom: 25,
            borderRadius: "8px",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={11}>
              <Typography fontWeight={"bold"}>Add User</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <IconButton onClick={handleClose}>
                <WSIcons.CloseIcon />
              </IconButton>
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Enter Full Name *"}
                {...register("fullName")}
                id="fullName"
                name="fullName"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                className="form-control"
                id="email"
                type={TextType.Text}
                rules={customValidation(false, validations.email)}
                {...register("email")}
                label="Email *"
                control={control}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSSelectField
                rules={{ required: true }}
                control={control}
                id="perc"
                {...register("role")}
                name="role"
                label="Choose Your Role *"
              />
            </Grid>
          </Grid>
        </Paper>
        <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
          <Grid item>
            <WSButton
              id="cancel"
              type="button"
              label="Cancel"
              size="medium"
              onClick={handleCancelClick}
              variant="outlined"
              color="primary"
            />
          </Grid>

          <Grid item>
            <WSButton
              id="submit"
              type="submit"
              label="Save"
              size="medium"
              variant="outlined"
              color="primary"
              loading={loading}
              onClick={handleSubmit(handleData)}
              sx={{
                borderRadius: 2,
                width: "6rem",
                border: "1px solid rgba(126, 176, 246, 1)",
                color: "#FFFFFF",
                backgroundColor: "rgba(126, 176, 246, 1)",
                "&:hover": {
                  backgroundColor: "rgba(126, 176, 246, 1)",
                },
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
});
